module.exports = __webpack_public_path__ + "static/hero-image-429a8a66f582ef8ea98cee3ff7f6ec03.jpg";